import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import AllProductsList from '../components/AdminComponents/AllProductsList';
import InnerBanner from '../components/PagesComponents/InnerBanner';
const AdminProducts = () => {
 return (
    <>
    {/* <InnerBanner pageKey="adminProducts" /> */}
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                     <AllProductsList/>
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminProducts;
